import dayjs from "dayjs";
import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { useTimeControlStore } from "./time-control-store";

type TimerStore = {
  time: Dayjs;
  setTime: (t: Dayjs) => void;
  setCurrentTime: () => void;
};

const store = set => ({
  time: dayjs(),
  setTime: (t: Dayjs) => {
    set({ time: t });
  },
  setCurrentTime: () => {
    useTimeControlStore.setState({ defaultTime: dayjs() });
    set({ time: dayjs() });
  }
});

export const useTimeStore = create<TimerStore>()(store);
